export type KeyShortcut = {
  name: string
  key: string
  displayName: string
  displayKey?: string | Array<string>
  permission?: string
}

export const keyMap: { [key: string]: KeyShortcut } = {
  1: {
    name: 'NEXT',
    key: 'k',
    displayName: 'Play next track',
    displayKey: 'K',
  },
  2: {
    name: 'PREV',
    key: 'j',
    displayName: 'Play previous track',
    displayKey: 'J',
  },
  3: { name: 'PLAYPAUSE', key: 'space', displayName: 'Play or pause' },
  4: {
    name: 'SEEKFORWARD',
    key: 'right',
    displayName: 'Seek forward 1s',
    displayKey: '→',
  },
  5: {
    name: 'SEEKBACKWARD',
    key: 'left',
    displayName: 'Seek backward 1s',
    displayKey: '←',
  },
  6: {
    name: 'SEEKFORWARDLONG',
    key: 'shift+ctrl+right',
    displayName: 'Seek forward 10s',
    displayKey: ['Ctrl', '⇧', '→'],
  },
  7: {
    name: 'SEEKBACKWARDLONG',
    key: 'shift+ctrl+left',
    displayName: 'Seek backward 10s',
    displayKey: ['Ctrl', '⇧', '←'],
  },
  8: {
    name: 'ADDTOCOLLECTION',
    key: 'c',
    displayName: 'Add playing track to collection',
    displayKey: 'C',
  },
  9: {
    name: 'ADDTOFAVORITES',
    key: 'f',
    displayName: 'Add playing track to favorites',
    displayKey: 'F',
  },
  10: {
    name: 'TOGGLELOOP',
    key: 'l',
    displayName: 'Toggle looping',
    displayKey: 'L',
  },
  11: {
    name: 'TOGGLESHORTCUTS',
    key: 'h',
    displayName: 'Show keyboard shortcuts',
    displayKey: 'H',
  },
  12: {
    name: 'SHOWADMINMODE',
    key: 'shift+p',
    displayName: 'Show admin mode in /tracks',
    displayKey: ['⇧', 'P'],
    permission: 'staff',
  },
  13: {
    name: 'OFFSETBEATFORWARD',
    key: 'shift+right',
    displayName: 'Offset beat forward',
    displayKey: ['⇧', '→'],
  },
  14: {
    name: 'OFFSETBEATBACKWARD',
    key: 'shift+left',
    displayName: 'Offset beat backward',
    displayKey: ['⇧', '←'],
  },
}

const mapValues: { [name: string]: string } = {}
Object.keys(keyMap).forEach(key => {
  const { name } = keyMap[key]
  mapValues[name] = keyMap[key].key
})

export default mapValues
